import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useIsLoggedIn, useDynamicContext } from "@dynamic-labs/sdk-react-core";

import { RootState } from "../redux/store";
import Loader from "../components/loader/loader";
import { useAppSelector } from "../hooks/useAppSelector";
import { useAppDispatch } from "../hooks/useAppDispatch";
import { getAccessToken, getLandingPageRoute } from "../common/utils";
import { getMyProfileData } from "../pages/my-profile/services/action";

const PublicRoute = ({ children }: any) => {
  const isLoggedIn = useIsLoggedIn();
  const { sdkHasLoaded } = useDynamicContext();

  const { myProfileData, isFetched } = useAppSelector(
    (state: RootState) => state.myProfile,
  );
  const { isLogin } = useAppSelector((state: RootState) => state.login);
  const { permissions, userType, hasSubscription } = myProfileData;
  const { userId } = useAppSelector((state: RootState) => state.verifyEmail);
  const dispatch = useAppDispatch();

  const [hasTimedOut, setHasTimedOut] = useState(false);

  useEffect(() => {
    let timerId: NodeJS.Timeout;

    if (isLoggedIn && getAccessToken() && !isLogin && !isFetched) {
      if (userId) {
        dispatch(getMyProfileData(userId));
      } else {
        setHasTimedOut(true);
      }

      timerId = setTimeout(() => {
        setHasTimedOut(true);
      }, 5000);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [isLoggedIn, isLogin, isFetched, userId, dispatch]);

  if (!sdkHasLoaded) {
    return <Loader open={true} />;
  }

  if (isLoggedIn && getAccessToken() && !isLogin) {
    if (!isFetched) {
      if (hasTimedOut) {
        return children;
      }
      return <Loader open={true} />;
    }

    if (!myProfileData || Object.keys(myProfileData).length === 0) {
      return children;
    }

    const landingPage = getLandingPageRoute(
      userType,
      permissions,
      hasSubscription,
    );

    return <Navigate to={landingPage} replace />;
  }

  return children;
};

export default PublicRoute;
